module.exports = __webpack_public_path__ + "img/andre-front.b2d9849c.jpg";